// extracted by mini-css-extract-plugin
module.exports = {"img":"Img_img__3cUUJ","placeholder":"Img_placeholder__12awy","imageContainer":"Img_imageContainer__5diWK"};